export const KEY_CODES = {
    tab: 9,
    enter: 13,
    esc: 27,
    up: 38,
    down: 40,
};

const SELECTABLE_ITEMS_QUERY = 'li[tabIndex="-1"]';

const itemsAndActiveIndex = dropDownMenu => {
    const items = dropDownMenu.current
        ? [...dropDownMenu.current.querySelectorAll(SELECTABLE_ITEMS_QUERY)]
        : [];
    const activeIndex = items.indexOf(document.activeElement);
    return { items, activeIndex };
};

const focusNext = (isExpanded, dropDownMenu, onClickDropDown) => {
    const { items, activeIndex } = itemsAndActiveIndex(dropDownMenu);

    if (!items.length) {
        return;
    }

    if (!isExpanded) {
        onClickDropDown();
    }
    const nextIndex = activeIndex + 1;
    items[nextIndex < items.length ? nextIndex : 0].focus();
};

const focusPrev = (isExpanded, dropDownMenu, onClickDropDown) => {
    const { items, activeIndex } = itemsAndActiveIndex(dropDownMenu);

    if (!items.length) {
        return;
    }

    if (!isExpanded) {
        onClickDropDown();
    }
    const prevIndex = activeIndex - 1;
    items[prevIndex >= 0 ? prevIndex : items.length - 1].focus();
};

const selectFocused = (dropDownMenu, onClickDropDown) => {
    const { items, activeIndex } = itemsAndActiveIndex(dropDownMenu);
    if (activeIndex >= 0) {
        items[activeIndex].click();
    }
    onClickDropDown();
};

const handleKeyDown = (event, isExpanded, dropDownMenu, onClickDropDown) => {
    switch (event.keyCode) {
        case KEY_CODES.down:
            event.preventDefault();
            focusNext(isExpanded, dropDownMenu, onClickDropDown);
            break;
        case KEY_CODES.up:
            event.preventDefault();
            focusPrev(isExpanded, dropDownMenu, onClickDropDown);
            break;
        case KEY_CODES.enter:
            event.preventDefault();
            selectFocused(dropDownMenu, onClickDropDown);
            break;
        case KEY_CODES.tab:
        case KEY_CODES.esc:
            if (isExpanded) onClickDropDown();
            break;
        default:
            break;
    }
};

export default handleKeyDown;
